import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import seedrandom from "seedrandom"
import $ from "jquery";

function isElementVisible(element) {
  const style = window.getComputedStyle(element);
  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    style.opacity !== '0'
  );
}

function getTranslate(element) {
  const rect = element.getBoundingClientRect();
  return {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2};
}

export class EarthLevel1 {

  constructor(el) {
    this.$el = $(el);
    this.init();
  }

  init() {
    gsap.set(this.$el.find("#earth-stars"), {autoAlpha: 0});
  }

  isBigEarthShown() {
    return isElementVisible(this.$el.find("#earth-big").get(0));
  }

  isStarsEarthShown() {
    return isElementVisible(this.$el.find("#earth-stars").get(0));
  }

  bringInFromStars(callback) {

    const tl = gsap.timeline();

    tl.set(this.$el.find("#earth-stars"), {autoAlpha: 1, scale: 1});
    tl.set(this.$el.find("#earth-big"), {autoAlpha: 0});

    this.$el.find("#earth-stars svg g path").each((i, n) => {

      const pos = getTranslate(n);
      const angle = Math.atan2(pos.y - 540, pos.x - 960);
      const duration = map(Math.random(), 0, 1, 0.3, 1);

      tl.fromTo($(n).parents(".transform-wrapper"), {
        scale: 0.5,
        x: Math.cos(angle) * 200 * map(Math.random(), 0, 1, 1, 1.5),
        y: Math.sin(angle) * 200 * map(Math.random(), 0, 1, 1, 1.5),
        autoAlpha: 0,
      }, {
        scale: 1,
        autoAlpha: 1,
        x: 0,
        y: 0,
        duration: 1.5,
        ease: "sine.out",
      }, duration)
    })

    tl.fromTo(this.$el.find("#earth-stars svg g.image"), {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: 1.5,
      ease: "sine.out",
    }, 1.15)

    tl.add(callback)
  }

  contractAndExplode() {

    const tl = gsap.timeline();

    tl.fromTo(this.$el.find("#earth-glow"), {autoAlpha: 0}, {
      autoAlpha: 1,
      duration: 0.3,
    }, 0.75)

    // Trigger lottie animation
    tl.add(() => {
      const lottie = $("#earth-glow .lottie-animation").data('lottie');
      lottie.setFrame(0)
      lottie.play();
    }, 2.45)

    tl.to(this.$el.find("#earth-stars"), {
      autoAlpha: 0,
      duration: 0.2,
      ease: "sine.in",
    }, "+=0.2")

    // Move down whole group and scale in
    tl.fromTo(this.$el.find("#earth-glow"), {
      scale: 1,
      y: 0,
    }, {
      scale: 1.75,
      y: 100,
      transformOrigin: "50% 50%",
      duration: 3,
      ease: "power1.inOut",
    }, '-=0.5')

    // Bring in big earth
    tl.add(this.bringInBigEarth(), "-=1.5")

    // Fade out
    tl.to(this.$el.find("#earth-glow"), {
      autoAlpha: 0,
      duration: 0.45,
      ease: "power1.in",
    }, '-=1.2')

    return tl;
  }

  bringInBigEarth() {

    const tl = gsap.timeline();

    tl.set(this.$el.find("#earth-stars"), {autoAlpha: 0});

    tl.fromTo(this.$el.find("#earth-big"), {
      autoAlpha: 0,
      y: 200,
      scale: 0.5,
    }, {
      autoAlpha: 1,
      y: 0,
      scale: 1,
      duration: 1.3,
    }, 0)

    return tl;
  }


  pullOutBigEarth() {
    const tl = gsap.timeline();
    tl.to(this.$el.find("#earth-big"), {
      autoAlpha: 0,
      y: 200,
      scale: 0.9,
      duration: .45,
    }, 0)
  }

  reset() {
    if (this.isBigEarthShown()) this.pullOutBigEarth();
    if (this.isStarsEarthShown()) gsap.to(this.$el.find("#earth-stars"), {autoAlpha: 0});
    gsap.set(this.$el.find("#earth-stars"), {rotation: 0});
  }

}
